// extracted by mini-css-extract-plugin
export default {"userIconContainer":"styles_userIconContainer__EaSCQ","userPhoto":"styles_userPhoto__X8FZy","isOnline":"styles_isOnline__BpHCU"};